import {
    createStyles,
    Theme,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import "moment-timezone";
import * as React from "react";
import Constants from "../../../models/utility/Constants";
import { Numbers } from "../../../models/utility/Numbers";

type IProps = WithStyles<typeof styles> & {
    bidIncrement?: number;
    text: string;
};

const WhiteTextTypography = withStyles({
    root: {
        color: "#FFFFFF"
    }
})(Typography) as typeof Typography;

const styles = (theme: Theme) =>
    createStyles({
        bidIncrementText: {
            [theme.breakpoints.down("xs")]: { fontSize: 10 },
            display: "block",
            fontWeight: "bold",
            marginTop: 5
        }
    });

function BidIncrementText(props: IProps) {
    const { bidIncrement, classes, text } = props;

    return (
        <WhiteTextTypography
            className={classes.bidIncrementText}
            component="span"
            variant="caption"
            color="textPrimary"
        >
            {text}{" "}
            {Numbers.toShortFormat(
                bidIncrement || Constants.DefaultBidIncrement
            )}
        </WhiteTextTypography>
    );
}

export default withStyles(styles)(BidIncrementText);
